import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { DateComponent } from './components/date/date.component'

import { SharedIconsModule } from '@alliance/shared/icons'
import { ClubsUtilsModule } from '@alliance/clubs/utils'

@NgModule({
  imports: [CommonModule, SharedIconsModule, ClubsUtilsModule],
  declarations: [DateComponent],
  exports: [DateComponent]
})
export class ClubsUiDateModule {}
